import styled from 'styled-components'

export const FillingGuideMedicalRecordModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;

  width: 100%;

  strong {
    color: #FC4949;
  }

  button {
    width: 100%;
  }
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  p {
    line-height: 22px;
  }

  strong {
    color: #1F35B5;
  }
`